import _ from 'lodash';
import { useState, useEffect } from 'react';
import { _capitalize } from 'chart.js/helpers';
import { useDispatch, useSelector } from "react-redux";
import {  Button, Form, Input, Popconfirm, Select, Table, Typography } from 'antd';

import { ListingRegulationKeysThunk, ListingRegulationValueThunk } from '../../Store/Thunks/ListingRegulationThunk';
import { splitStringIntoTwoLines } from '../../Helpers/ValueFormater';
import { ApiPutListingRegulationValue} from '../../Services';

const EditableCell = ({
  editing,
  dataIndex,
  title,
  inputType,
  record,
  index,
  children,
  ListingGeneralValueData,
  ...restProps
}) => {
  const micaClassificationValueData = Object.freeze([
    { name: " ", key: null },
    { name: "ART", key: "ART" },
    { name: "EMT", key: "EMT" },
    { name: "OCA", key: "OCA" },
    { name: "MEME", key: "MEME" }, 
    { name: "NFT", key: "NFT" },
    { name: "CASP", key: "CASP" },
    { name: "Utility Token", key: "Utility Token" }, 
  
  ]);
  const esmaClassificationValueData = Object.freeze([
    { name: " ", key: null },
    { name: "FI", key: "FI" },
    { name: "Not FI", key: "Not FI" },
   
  ]);
    const 	privacyCoin = Object.freeze([
    { name: " ", key: null },
    { name: "Yes", key: "Yes" },
    { name: "No", key: "No" },
   
  ]);
  return (
    <td {...restProps}>
    {editing ? ( 
          <>
          <Form.Item name={[record.key, dataIndex]} style={{ margin: 0 }}>
            <Select style={{ width: "80%" }}> 
              {dataIndex === "micaClassification"
                ? micaClassificationValueData.map((option) => (
                    <Select.Option key={option.key} value={option.key}>
                      {option.name}
                    </Select.Option>
                  ))
                : dataIndex === "privacyCoin" ?
                privacyCoin.map((option) => (
                    <Select.Option key={option.key} value={option.key}>
                      {option.name}
                    </Select.Option>
                  ))
                : esmaClassificationValueData.map((option) => (
                    <Select.Option key={option.key} value={option.key}>
                      {option.name}
                    </Select.Option>
                  ))}
            </Select>
          </Form.Item>
            {dataIndex === "micaClassification" &&  <Form.Item 
              name={[record.key, `${dataIndex}Desc`]} 
              style={{ margin: 0 }}>
                <Input style={{ width: "80%" }}/>
          </Form.Item>}
          </>
        ) : (
         record ? <>  <p>{record[dataIndex]} </p> <p>{record[`${dataIndex}Desc`]} </p></> : children 
        )
        }
  </td>
  );
};

export default EditableCell;

export const Regulation = () => {
  const [form] = Form.useForm();
  const dispatch = useDispatch();

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [editingKey, setEditingKey] = useState('');
  const [isSaveClicked, setIsSaveClicked] = useState(false);
  const [modifiedRows, setModifiedRows] = useState(new Set());
 const [selectedRowKeys, setSelectedRowKeys] = useState([]);
 const [bulkEditing, setBulkEditing] = useState(false);

  useEffect(() => {
    dispatch(ListingRegulationKeysThunk());
    dispatch(ListingRegulationValueThunk());
  }, []);

  const {
    ListingRegulationKeyData,
    ListingRegulationKeyLoading,
    ListingRegulationValueData,
    ListingRegulationValueLoading,
  } = useSelector((state) => state.ListingRegulationReducer);

  const isEditing = (record) => bulkEditing || record.key === editingKey;
  const edit = (record) => {
  const { key, ...rest } = record;

      form.setFieldsValue({
        [key]: rest,
      });

      setEditingKey(key);
    };


    const cancel = () => {
        setEditingKey('');
    };

  const dataSource = () => {
    const arr = [];
    ListingRegulationValueData.map((item, index) => {    
      const obj = {};
      ListingRegulationKeyData.map((element) => {
        if (item.listingRegulation) {         
          obj[element.key] = item.listingRegulation[element.key];   
          obj[`${element.key}Desc`] = item.listingRegulation[`${element.key}Desc`];      
          obj.id = item.listingRegulation.id;
        } else {       
          obj[element.key] = ""; 
          obj[`${element.key}Desc`] = "";
          obj.id = item.id;
        }
      });
      
      arr.push({
        name: item.assetName,
        ...obj,
        key: index,
      });
    });
      
    setData(arr);
    return arr;
  };


  useEffect(() => {
    if (ListingRegulationKeyData?.length && ListingRegulationValueData.length) {
      dataSource();
    }
  }, [ListingRegulationKeyData, ListingRegulationValueData]);
   
  const editAssetValue = () => {
    setLoading(true);
  
    const editData = Array.from(modifiedRows).reduce((acc, cellId) => {
   
      if (typeof cellId === "string") {
        const [rowId, colKey] = cellId.split('_');
        const row = data.find((item) => item.id === parseInt(rowId, 10));
        if (!row) return acc;
  
        // Find or initialize an item in acc for this row ID
        let newItem = acc.find((item) => item.id === row.id);
        if (!newItem) {
          newItem = { id: row.id }; // Initialize a new item for this row if not found
          acc.push(newItem);
        }
  
        // Set only modified fields in newItem
        const value = row[colKey]; 
        newItem[colKey] = value;
         
        }
      
      return acc;
    }, []);
     
    if (editData.length > 0) {
      ApiPutListingRegulationValue({ regulations: editData })
        .then(() => {
          setLoading(false);
          setModifiedRows(new Set());
          setIsSaveClicked(true);

          dispatch(ListingRegulationKeysThunk());
          dispatch(ListingRegulationValueThunk());
        })
        .catch(() => {
          setLoading(false);
          setIsSaveClicked(false);
        });
    } else {
      setLoading(false); 
    }
  };
  
const save = async (key) => {
  try {
    const values = await form.validateFields();
    const rowValues = values[key]; 

    const newData = [...data];
    const index = newData.findIndex(item => item.key === key);

    if (index > -1) {
      const item = newData[index];

      Object.keys(rowValues).forEach(colKey => {
        if (rowValues[colKey] !== item[colKey]) {
          item[colKey] = rowValues[colKey];
          setModifiedRows(prev =>
            new Set(prev).add(`${item.id}_${colKey}`)
          );
        }
      });

      newData[index] = { ...item };
      setData(newData);
      setEditingKey('');
      setIsSaveClicked(true);
    }
  } catch (err) {
    console.log(err);
  }
};

  useEffect(()=>{
    if(modifiedRows && isSaveClicked){
      editAssetValue();
    }
    setIsSaveClicked(false)
  },[modifiedRows,isSaveClicked])

  const columns = () => {
    return [
      {
        title: "#",
        dataIndex: "index",
        key: "index",
        width: 60,
        render: (text, record, index) => index + 1,
      },
      {
        title: 'Asset',
        dataIndex: 'name',
        fixed: 'left',
        width: 100,

      },
     ...ListingRegulationKeyData
          .filter(item => !item.key.endsWith('Desc')) // ⬅️ HIDE description columns
          .map(item => ({
            title: splitStringIntoTwoLines(item.name),
            dataIndex: item.key,
            editable: true,
            render: (text) => text,
          })),
      {
        title: 'Operation',
        dataIndex: 'operation',
        fixed: 'right',
        width: 100,
        render: (_, record) => {
          const editable = isEditing(record);         
          return editable && !bulkEditing  ? (
            <span>
              <Typography.Link
                onClick={() => save(record.key)}
                style={{ marginRight: 8 }}
              >
                Save
              </Typography.Link>
                <Popconfirm
                    title="Sure to cancel?"
                    okText="Cancel"
                    cancelText="No"
                    okButtonProps={{ style: { float: 'right' } }}
                    cancelButtonProps={{ style: { float: 'left' } }}
                    onConfirm={cancel}
                    overlayStyle={{ paddingBottom:"20px" }}
                  >
                    <a>Cancel</a>
                |</Popconfirm>
            </span>
          ) : !bulkEditing  ? (
            <Typography.Link disabled={editingKey !== ''} onClick={() => edit(record)}>
              Edit
            </Typography.Link>
          ): null
        },
      },
    ];
  };

  const mergedColumns = columns().map((col) => {
    
    if (!col.editable) {
      return col;
    }
    return {
      ...col,
      onCell: (record) => ({
        record,
        inputType: col.inputType,
        dataIndex: col.dataIndex,
        title: col.title,
        editing: isEditing(record),
        ListingRegulationValueData
      }),
    };
  });

const rowSelection = {
  selectedRowKeys,
  onChange: (keys) => setSelectedRowKeys(keys),
  getCheckboxProps: (record) => ({
    disabled: editingKey !== '' && !selectedRowKeys.includes(record.key),
  }),
};

const bulkEdit = () => {
  const values = {};

  data.forEach(row => {
    if (selectedRowKeys.includes(row.key)) {
      values[row.key] = row;
    }
  });

  form.setFieldsValue(values);
  setBulkEditing(true);
};
const bulkSave = async () => {
  try {
    const values = await form.validateFields();
    const newData = [...data];
    const newModified = new Set(modifiedRows);

    Object.keys(values).forEach(rowKey => {
      const index = newData.findIndex(r => r.key === Number(rowKey));
      if (index === -1) return;

      const row = newData[index];
      const rowValues = values[rowKey];

      Object.keys(rowValues).forEach(colKey => {
        if (row[colKey] !== rowValues[colKey]) {
          newModified.add(`${row.id}_${colKey}`);
          row[colKey] = rowValues[colKey];
        }
      });
    });

    setData(newData);
    setModifiedRows(newModified);

    setBulkEditing(false);
    setSelectedRowKeys([]);
    setIsSaveClicked(true);
  } catch (e) {
    console.log(e);
  }
};

  return (
    <div>
 
      <Form form={form} component={false} >
        <Table
          loading={ListingRegulationKeyLoading || ListingRegulationValueLoading || loading}
            rowSelection={rowSelection}

          components={{
            body: {
              cell: EditableCell,
            },
          }}
          className="custom-scroll"
          pagination={false}
          bordered
          dataSource={data}
          columns={mergedColumns}
          rowClassName="editable-row"       
          scroll={{ y: 500 }}
        />
      </Form>
      <div style={{ marginTop: 16 }}>
  <Button
    disabled={!selectedRowKeys.length || editingKey !== ''}
    onClick={bulkEdit}
  >
    Bulk Edit
  </Button>

  {bulkEditing && (
    <>
      <Button
        type="primary"
        style={{ marginLeft: 8 }}
        onClick={bulkSave}
      >
        Bulk Save
      </Button>

      <Button
        style={{ marginLeft: 8 }}
        onClick={() => {
          setBulkEditing(false);
          setSelectedRowKeys([]);
          form.resetFields();
        }}
      >
        Cancel
      </Button>
    </>
  )}
      </div>
    </div>
  );
};